import { ReactElement } from 'react';

import {
  Button,
  HexIcon,
  HexIconElementProps,
  Icons,
  Placeholder,
  ExternalLink,
} from '@cast/design-system';

import { getDocsLink } from '@cast/utils';

type Props = {
  title: string;
  testId: string;
  actionLabel: string;
  onActionClick: () => void;
  icon?: ReactElement<HexIconElementProps>;
};

export const EdgeConfigurationsOnboardingBase = ({
  title,
  testId,
  actionLabel,
  onActionClick,
  icon = <Icons.Nut />,
}: Props) => {
  return (
    <Placeholder
      testId={testId}
      icon={
        <HexIcon
          size={64}
          icon={icon}
          iconColor="blue.500"
          hexColor="blue.300"
          sx={{ mb: 4 }}
        />
      }
      title={title}
      titleProps={{ variant: 'h5' }}
      body={
        <>
          Extend your cluster beyond its primary region to access compute
          capacity in different regions and cloud providers. Once created, edge
          locations can be used by the Autoscaler to optimize node placement.{' '}
          <ExternalLink
            link={getDocsLink('docs_omni_overview')}
            iconProps={{ size: 16 }}
          >
            Documentation
          </ExternalLink>
        </>
      }
      bodyProps={{ variant: 'P14R', sx: { maxWidth: '684px' } }}
      actions={
        <Button
          testId={`${testId}-button`}
          onClick={onActionClick}
          variant="primary"
        >
          {actionLabel}
        </Button>
      }
    />
  );
};
